import React, { useEffect } from "react";
import "./Dashboard.css";
import { connect } from "react-redux";
import DashSearch from "components/DashSearch";
import { fetchSearch } from "containers/Dashboard/actions";
import { useTheme } from "context/themeContext";
import DOMPurify from "dompurify";
import { useOperatorNavigate } from "utils/navigationHelper";
import { redirectDashboard } from "routes/RedirectRoutes";
import { fetchRoute } from "containers/BuyOperatorToken/actions";
import { message } from "antd";

const qr_img = require("images/device-token.svg");
const history_img = require("images/token history.svg");

const Dashboard = ({ fetchSearch, selectOperatorState, fetchRoute }) => {
  const { colorTheme, logoUrl, whiteLabelName, canReserve } = useTheme();
  const navigate = useOperatorNavigate();
  
  const navigateTransaction = () => {
    navigate("/transactions/email");
  };

  useEffect(() => {
    if (whiteLabelName) {
      fetchRoute(whiteLabelName);
    }
  }, [whiteLabelName, fetchRoute]);

  const handleSearch = (searchData) => {
   
    // ✅ double check in case DashSearch misses validation
    if (canReserve) {
      if (
        !searchData.origin ||
        !searchData.destination ||
        !searchData.departureDate
      ) {
        message.error("Please select origin, destination and date before searching.");
        return;
      }
    }
    fetchSearch(searchData);
  };

 
  

  return (
    <div className="main-section">
      <div className="topBar">
        <img
          src={DOMPurify.sanitize(logoUrl)}
          alt={`${whiteLabelName} logo`}
          style={{
            width: "80px",
            height: "auto",
            objectFit: "fit",
            maxHeight: "80px",
          }}
        />
        <div
          onClick={redirectDashboard}
          style={{ color: colorTheme, cursor: "pointer" }}
        >
          Go Home
        </div>
      </div>

      <main className="dashboard__main">
        <div className="dashboard_header">
          <h3 style={{ textAlign: "center", marginTop: "10px" }}>
            Get transport ticket to any destination.
          </h3>
        </div>

        <div className="search_container">
          <DashSearch
            selectOperatorState={selectOperatorState}
            searchState={handleSearch}
          />
        </div>

        <div className="search_container">
          <div className="row g-4 mt-4 justify-content-center ">
            <div
              className="d-flex justify-content-center mb-3 mr-3"
               onClick={() => handleSearch({ whitelabel: whiteLabelName, canReserve })}
            >
              <div className="dash_card d-flex justify-content-center align-items-end">
                <div className="text-center">
                  <img
                    src={qr_img}
                    style={{ height: "40%", width: "40%" }}
                    alt="buy token"
                  />
                  <p
                    className="pt-3 pb-3 dash_text"
                    style={{ color: colorTheme }}
                  >
                    Buy Transport Ticket
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mb-3 mx-3">
              <div onClick={navigateTransaction}>
                <div className="dash_card d-flex justify-content-center align-items-end">
                  <div className="text-center">
                    <img
                      src={history_img}
                      style={{ height: "40%", width: "40%" }}
                      alt="transaction history"
                    />
                    <p
                      className="pt-3 pb-3 dash_text"
                      style={{ color: colorTheme }}
                    >
                      Transaction History
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

const mapStateToProps = ({ common, individual, selectOperatorState }) => {
  const { display, message, loading } = common;
  const { loading_dashboard, dashboard } = individual;
  return {
    display,
    message,
    loading,
    individual,
    dashboard,
    loading_dashboard,
    selectOperatorState,
  };
};

Dashboard.defaultName = "DashboardPage";

export default connect(mapStateToProps, { fetchSearch, fetchRoute })(Dashboard);
